// Chamado de garçom no painel: consulta periódica, som enquanto ninguém atende.
// A mesma consulta traz `qr_recusando`: o motivo pelo qual o QR recusa TODO
// cliente agora (hoje só "CAIXA_FECHADO") — vira a faixa da tela de Mesas.
//
// Vive no Dashboard e não na tela de Mesas de propósito: o garçom pode estar em
// Pedidos, no Balcão ou no Delivery quando o cliente aperta o botão. Os sons
// que existiam antes tocavam só na tela dona deles, o que aqui não serviria.
import { useCallback, useEffect, useRef, useState } from "react";

import { atenderChamado, listarChamados } from "./api";
import { tocarChamado } from "./somChamado";

const INTERVALO_CONSULTA_MS = 10000;

export function useChamadosGarcom({ ativo }) {
  const [chamados, setChamados] = useState([]);
  const [som, setSom] = useState(null);
  const [qrRecusando, setQrRecusando] = useState(null);
  const ultimoToque = useRef(0);

  const consultar = useCallback(async () => {
    try {
      const { data } = await listarChamados();
      setChamados(data?.chamados || []);
      setSom(data?.som || null);
      setQrRecusando(data?.qr_recusando || null);
    } catch {
      setChamados([]);
    }
  }, []);

  useEffect(() => {
    if (!ativo) return undefined;
    consultar();
    const id = setInterval(consultar, INTERVALO_CONSULTA_MS);
    return () => clearInterval(id);
  }, [ativo, consultar]);

  // Repete enquanto houver chamado aberto, respeitando o intervalo configurado.
  useEffect(() => {
    if (!ativo || chamados.length === 0 || !som) return undefined;
    const intervaloMs = Math.max(5, Number(som.intervalo || 20)) * 1000;
    const bater = () => {
      const agora = Date.now();
      if (agora - ultimoToque.current < intervaloMs - 500) return;
      ultimoToque.current = agora;
      tocarChamado(som);
    };
    bater();
    const id = setInterval(bater, intervaloMs);
    return () => clearInterval(id);
  }, [ativo, chamados.length, som]);

  const atender = useCallback(async (mesaId) => {
    try {
      await atenderChamado(mesaId);
    } catch {
      /* o próximo ciclo mostra o estado real */
    }
    setChamados((atuais) => atuais.filter((c) => c.mesa_id !== mesaId));
  }, []);

  return { chamados, atender, recarregar: consultar, qrRecusando };
}
